import {AUTH_SESSION, AUTH_USER_EMAIL_KEY} from "./types";

const coreApiEndpoint = (window.location.hostname === "localhost")
    ? (window.location.protocol + '//' + window.location.hostname + ":8090/promises12/api")
    : (window.location.protocol + '//' + window.location.host + "/promises12/api") ;

const AUTH_ACCESS_TOKEN = "stackleader.auth.access_token";
const AUTH_REFRESH_TOKEN = "stackleader.auth.refresh_token";
const AUTH_EXPIRES_IN = "stackleader.auth.expires_in";
const AUTH_SCOPE = "stackleader.auth.scope";
const AUTH_TOKEN_TYPE = "stackleader.auth.token_type";
const AUTH_CLOCK_START = "stackleader.auth.clock_start";

const AUTH_CODE_EXPIRED_TOKEN = "stackleader.auth.code.expired_token"
const AUTH_NO_SESSION = "stackleader.auth.no_session"

enum HttpMethod {
    GET = "GET", HEAD = "HEAD", POST = "POST", PUT = "PUT", PATCH = "PATCH", DELETE = "DELETE", OPTIONS = "OPTIONS", TRACE = "TRACE"
}

// function handleResponse(response: Response) {
//     if (response.ok) {
//         return response.json();
//     } else {
//         return response.json().then(function (error) {
//             throw error;
//         });
//     }
// }
//
//
// function handleNetworkError(error: Error) {
//     throw error;
// }

// type logout = () => Function;

export const logout = () => {
    localStorage.removeItem(AUTH_USER_EMAIL_KEY);
    localStorage.removeItem(AUTH_ACCESS_TOKEN);
    localStorage.removeItem(AUTH_REFRESH_TOKEN);
    localStorage.removeItem(AUTH_EXPIRES_IN);
    localStorage.removeItem(AUTH_SCOPE);
    localStorage.removeItem(AUTH_TOKEN_TYPE);
    localStorage.removeItem(AUTH_CLOCK_START);
}

export type OAuthSession = {
    access_token: string,
    token_type: string,
    expires_in: string,
    refresh_token: string,
    scope: string,
    session?: string
}

type signInCode = (email: string, code: string) => Promise<OAuthSession>;

export const signInCode: signInCode = (async (username, code) => {

    const formBody = [];
    formBody.push(encodeURIComponent("client_id") + "=" + encodeURIComponent(username));
    formBody.push(encodeURIComponent("code") + "=" + encodeURIComponent(code));
    formBody.push(encodeURIComponent("grant_type") + "=" + encodeURIComponent("authorization_code"));
    formBody.push(encodeURIComponent("scope") + "=" + encodeURIComponent("/api"));
    let formBodyText = formBody.join("&");

    return fetch(coreApiEndpoint + "/oauth/token", {
        mode: 'cors',
        credentials: 'include',
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem(AUTH_ACCESS_TOKEN),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            Pragma: 'no-cache'
        },
        body: formBodyText,
        method: HttpMethod.POST
    })
        .then(function (a) {
            if (a.ok) {
                return a.json().then(function (b: OAuthSession) {
                    localStorage.setItem(AUTH_ACCESS_TOKEN, b.access_token);
                    localStorage.setItem(AUTH_REFRESH_TOKEN, b.refresh_token);
                    localStorage.setItem(AUTH_EXPIRES_IN, b.expires_in);
                    localStorage.setItem(AUTH_SCOPE, b.scope);
                    localStorage.setItem(AUTH_TOKEN_TYPE, b.token_type);
                    localStorage.setItem(AUTH_CLOCK_START, Date.now().toString())
                    if(b.session !== undefined) {
                        localStorage.setItem(AUTH_SESSION, b.session);
                    }
                    return b;
                });
            }
            return a.json().then(function (e) {
                throw e;
            });
        });
});

type signIn = (email: string, password: string) => Promise<OAuthSession>;

export const signIn: signIn = (async (username, password) => {

    let sessionId = localStorage.getItem(AUTH_SESSION);
    const formBody = [];
    formBody.push(encodeURIComponent("client_id") + "=" + encodeURIComponent(username));
    formBody.push(encodeURIComponent("client_secret") + "=" + encodeURIComponent(password));
    formBody.push(encodeURIComponent("grant_type") + "=" + encodeURIComponent("client_credential"));
    formBody.push(encodeURIComponent("scope") + "=" + encodeURIComponent("/api"));
    if(sessionId !== undefined && sessionId !== null) {
        formBody.push(encodeURIComponent("code") + "=" + encodeURIComponent(sessionId));
    }
    let formBodyText = formBody.join("&");

    return fetch(coreApiEndpoint + "/oauth/token", {
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            Pragma: 'no-cache'
        },
        body: formBodyText,
        method: HttpMethod.POST
    })
        .then(function (a) {
            if (a.ok) {
                return a.json().then(function (b: OAuthSession) {
                    localStorage.setItem(AUTH_ACCESS_TOKEN, b.access_token);
                    localStorage.setItem(AUTH_REFRESH_TOKEN, b.refresh_token);
                    localStorage.setItem(AUTH_EXPIRES_IN, b.expires_in);
                    localStorage.setItem(AUTH_SCOPE, b.scope);
                    localStorage.setItem(AUTH_TOKEN_TYPE, b.token_type);
                    localStorage.setItem(AUTH_CLOCK_START, Date.now().toString())
                    return b;
                });
            }
            return a.json().then(function (e) {
                throw e;
            });
        });
});

type signInClientFile = (clientId: string, key: string, passcode: string) => Promise<OAuthSession>;

export const signInClientFile: signInClientFile = (async (clientId, key, passcode) => {

    const formBody = [];
    formBody.push(encodeURIComponent("client_id") + "=" + encodeURIComponent(clientId));
    formBody.push(encodeURIComponent("client_secret") + "=" + encodeURIComponent(key));
    formBody.push(encodeURIComponent("code") + "=" + encodeURIComponent(passcode));
    formBody.push(encodeURIComponent("grant_type") + "=" + encodeURIComponent("client_credential"));
    formBody.push(encodeURIComponent("scope") + "=" + encodeURIComponent("/clients/"+clientId));

    let formBodyText = formBody.join("&");

    return fetch(coreApiEndpoint + "/oauth/token", {
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            Pragma: 'no-cache'
        },
        body: formBodyText,
        method: HttpMethod.POST
    })
        .then(function (a) {
            if (a.ok) {
                return a.json().then(function (b: OAuthSession) {
                    // localStorage.setItem(AUTH_ACCESS_TOKEN, b.access_token);
                    // localStorage.setItem(AUTH_REFRESH_TOKEN, b.refresh_token);
                    // localStorage.setItem(AUTH_EXPIRES_IN, b.expires_in);
                    // localStorage.setItem(AUTH_SCOPE, b.scope);
                    // localStorage.setItem(AUTH_TOKEN_TYPE, b.token_type);
                    // localStorage.setItem(AUTH_CLOCK_START, Date.now().toString())
                    return b;
                });
            }
            return a.json().then(function (e) {
                throw e;
            });
        });
});


//
type currentSession = () => Promise<OAuthSession>;

export const currentSession: currentSession = (() => {
    const accessToken = localStorage.getItem(AUTH_ACCESS_TOKEN);
    if (!accessToken) {
        return new Promise<OAuthSession>(function (resolve, reject) {
            reject({
                message: "session does not exist",
                code: AUTH_NO_SESSION
            })
        })
    }
    const clockStart = parseInt(localStorage.getItem(AUTH_CLOCK_START) || "0");
    const elapsedTime = Math.floor((Date.now() - clockStart) / 1000);
    console.log("elapsed time: " + elapsedTime);
    const expiresIn = parseInt(localStorage.getItem(AUTH_EXPIRES_IN) || "0");

    const timeRemaining = expiresIn - elapsedTime;
    console.log("time remaining: " + timeRemaining);
    if (timeRemaining > 900) {
        return new Promise<OAuthSession>(function (resolve, reject) {
                resolve({
                    access_token: accessToken,
                    refresh_token: localStorage.getItem(AUTH_REFRESH_TOKEN) || "",
                    expires_in: localStorage.getItem(AUTH_EXPIRES_IN) || "",
                    scope: localStorage.getItem(AUTH_SCOPE) || "",
                    token_type: localStorage.getItem(AUTH_TOKEN_TYPE) || ""
                })
            }
        );
    } else if (timeRemaining < 900 && timeRemaining > 0) {
        return refreshToken();
    }
    return new Promise<OAuthSession>(function (resolve, reject) {
        reject({
            message: "expired token",
            code: AUTH_CODE_EXPIRED_TOKEN
        })
    });

});

const refreshToken = () => {
    console.log("refreshing token")
    const formBody = [];
    formBody.push(encodeURIComponent("refresh_token") + "=" + encodeURIComponent(localStorage.getItem(AUTH_REFRESH_TOKEN) || ""));
    formBody.push(encodeURIComponent("grant_type") + "=" + encodeURIComponent("refresh_token"));
    formBody.push(encodeURIComponent("scope") + "=" + encodeURIComponent("/api"));
    let formBodyText = formBody.join("&");
    return fetch(coreApiEndpoint + "/oauth/token", {
        mode: 'cors',
        credentials: 'include',
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem(AUTH_ACCESS_TOKEN),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            Pragma: 'no-cache'
        },
        body: formBodyText,
        method: HttpMethod.POST
    })
        .then(function (a) {
            if (a.ok) {
                return a.json().then(function (b: OAuthSession) {
                    localStorage.setItem(AUTH_ACCESS_TOKEN, b.access_token);
                    localStorage.setItem(AUTH_REFRESH_TOKEN, b.refresh_token);
                    localStorage.setItem(AUTH_EXPIRES_IN, b.expires_in);
                    localStorage.setItem(AUTH_SCOPE, b.scope);
                    localStorage.setItem(AUTH_TOKEN_TYPE, b.token_type);
                    localStorage.setItem(AUTH_CLOCK_START, Date.now().toString())
                    return b;
                });
            }
            return a.json().then(function (e) {
                throw e;
            });
        });
}